import React from "react";
import BaseSvg from "./baseSvg";

const FeeMask = () => (
  <BaseSvg data-qa-label="fee-loading-mask" height="16" width="42" />
);

export default React.memo(FeeMask);
